import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../services/api';

// inline styles to avoid styled-components dependency
const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    position: 'relative',
    overflow: 'hidden',
  },
  grid: {
    position: 'absolute', inset: 0,
    backgroundImage: `
      linear-gradient(rgba(0,229,255,0.03) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0,229,255,0.03) 1px, transparent 1px)
    `,
    backgroundSize: '40px 40px',
    pointerEvents: 'none',
  },
  box: {
    width: '100%',
    maxWidth: '400px',
    position: 'relative',
    zIndex: 1,
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
  },
  logo: {
    width: '56px', height: '56px',
    background: 'rgba(0,229,255,0.08)',
    border: '1px solid rgba(0,229,255,0.2)',
    borderRadius: '14px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    margin: '0 auto 20px',
    fontSize: '24px',
  },
  title: {
    fontFamily: 'Syne, sans-serif',
    fontSize: '28px',
    fontWeight: '800',
    color: '#e2eaf3',
    letterSpacing: '-0.02em',
    marginBottom: '6px',
  },
  sub: {
    fontSize: '12px',
    color: '#7a90a4',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
  },
  card: {
    background: '#0d1117',
    border: '1px solid #1e2a36',
    borderRadius: '16px',
    padding: '32px',
  },
  label: {
    display: 'block',
    fontSize: '11px',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#7a90a4',
    marginBottom: '8px',
  },
  fieldWrap: { marginBottom: '20px' },
  error: {
    background: 'rgba(255,59,92,0.1)',
    border: '1px solid rgba(255,59,92,0.3)',
    borderRadius: '8px',
    padding: '12px 16px',
    color: '#ff3b5c',
    fontSize: '12px',
    marginBottom: '20px',
  },
  submitBtn: {
    width: '100%',
    padding: '14px',
    background: '#00e5ff',
    color: '#080b10',
    border: 'none',
    borderRadius: '10px',
    fontFamily: 'JetBrains Mono, monospace',
    fontSize: '13px',
    fontWeight: '700',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    cursor: 'pointer',
    transition: 'all 0.2s',
    boxShadow: '0 0 20px rgba(0,229,255,0.2)',
  },
  footer: {
    textAlign: 'center',
    marginTop: '24px',
    fontSize: '11px',
    color: '#3d5166',
  }
};

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('adminToken')) navigate('/admin/dashboard');
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await adminLogin(username, password);
      if (data.token && data.message === 'ADMIN') {
        localStorage.setItem('adminToken', data.token);
        navigate('/admin/dashboard');
      } else if (data.token) {
        // Valid login but not an admin — reject access
        setError('Access denied. Admin account required.');
      } else {
        setError('Invalid credentials');
      }
    } catch {
      setError('Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.grid} />
      <div style={styles.box} className="fade-up">
        <div style={styles.header}>
          <div style={styles.logo}>🔐</div>
          <h1 style={styles.title}>SecretChat</h1>
          <p style={styles.sub}>Admin Console</p>
        </div>

        <div style={styles.card}>
          <form onSubmit={handleSubmit}>
            {error && <div style={styles.error}>{error}</div>}

            <div style={styles.fieldWrap}>
              <label style={styles.label}>Username</label>
              <input
                className="input"
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="admin"
                autoComplete="username"
                required
              />
            </div>

            <div style={styles.fieldWrap}>
              <label style={styles.label}>Password</label>
              <input
                className="input"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
                required
              />
            </div>

            <button
              type="submit"
              style={styles.submitBtn}
              disabled={loading}
            >
              {loading ? 'Authenticating...' : '→ Sign In'}
            </button>
          </form>
        </div>

        <p style={styles.footer}>SECRET CHAT v1.0 · ENCRYPTED · EPHEMERAL</p>
      </div>
    </div>
  );
}
